"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
exports.default = (0, react_1.forwardRef)(function (props, ref) { return (react_1.default.createElement("svg", __assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", ref: ref }, props),
    react_1.default.createElement("g", null,
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.3641 3.05037C14.7546 2.65984 14.7546 2.02668 14.3641 1.63615C13.9736 1.24563 13.3404 1.24563 12.9499 1.63615L8.00011 6.58591L3.05037 1.63617C2.65985 1.24564 2.02668 1.24564 1.63616 1.63617C1.24563 2.02669 1.24563 2.65986 1.63616 3.05038L6.5859 8.00012L1.63615 12.9499C1.24563 13.3404 1.24563 13.9736 1.63615 14.3641C2.02668 14.7546 2.65984 14.7546 3.05037 14.3641L8.00011 9.41434L12.9499 14.3641C13.3404 14.7546 13.9736 14.7546 14.3641 14.3641C14.7546 13.9736 14.7546 13.3404 14.3641 12.9499L9.41432 8.00012L14.3641 3.05037Z", fill: "currentColor" })))); });
//# sourceMappingURL=LargeClose.js.map